/**
 * Messages d'erreur client : jamais de détail technique (auth, réseau, HTTP, stack…).
 * Seules les consignes UX courtes et allowlistées passent.
 */

export const GENERIC_USER_ERROR = 'Une erreur est survenue. Réessaie plus tard.';

/** Messages UX autorisés (validation / consignes métier, pas de fuite technique). */
const ALLOWED_EXACT = new Set([
  'Votre panier est vide',
  'Veuillez entrer une adresse de livraison',
  'Veuillez entrer un nom',
  'Le nom est requis',
  'Vous ne pouvez pas utiliser votre propre code de parrainage',
  'Code de parrainage invalide.',
  'Code de parrainage invalide. Veuillez entrer un code valide ou laisser le champ vide.',
  'Erreur lors de la validation du code de parrainage.',
  'Erreur lors de la copie',
  "Entre un pseudo d'au moins 2 caractères.",
  'Pseudo trop long (max 32).',
  "Pseudo manquant — retourne à l'étape nom.",
  'Dépôt non validé — recommence une activation.',
  'Identifiant Telegram introuvable. Rouvre depuis le bot.',
  'Session expirée — rouvre l’app depuis Telegram.',
  "Session expirée — rouvre l'app depuis Telegram.",
  'Ce nom de commande est déjà utilisé. Choisissez un nom différent.',
  'Ce nom est déjà utilisé par un autre client',
  'La boutique est actuellement fermée',
  'Panier vide',
  'Paiement en Global Coins non validé. Réessayez.',
  'Montant en Global Coins insuffisant pour cette commande.',
]);

const ALLOWED_RE = [
  /^minimum de commande/i,
  /^pour bénéficier/i,
  /^ajoutez plus de produits/i,
  /^vous avez déjà une commande/i,
  /^⚠️?\s*vous avez déjà une commande/i,
  /^pass expiré/i,
  /^boutique fermée/i,
  /^la boutique est actuellement fermée/i,
  /^shop (is )?closed/i,
  /^zone non/i,
  /^compte créé/i,
  /^profil créé/i,
  /^ce nom/i,
  /^session expirée/i,
  /^paiement en global coins/i,
  /^montant en global coins/i,
  /^prix invalide/i,
  /^produit invalide/i,
  /^quantité invalide/i,
];

const TECH_RE = [
  /non autoris/i,
  /preuve d['’]?identit/i,
  /initData/i,
  /pwaToken|pwa.?token/i,
  /deviceId|device.?id/i,
  /erreur r[eé]seau/i,
  /network\s*error/i,
  /connection error/i,
  /erreur de connexion/i,
  /\bHTTP\b/i,
  /\b(401|403|404|500|502|503)\b/,
  /timeout|ECONN|ENOTFOUND|fetch failed/i,
  /Forbidden|Unauthorized/i,
  /cors/i,
  /webhook/i,
  /stack|TypeError|ReferenceError|SyntaxError/i,
  /chatId|telegramChatId/i,
  /JSON\.parse|Unexpected token/i,
  /undefined|null is not/i,
  /Accès refusé|Access denied/i,
  /introuvable|not found/i,
  /serveur|server error/i,
];

/**
 * @param {unknown} raw
 * @returns {string}
 */
export function safeUserError(raw) {
  const msg = String(raw ?? '').trim();
  if (!msg) return GENERIC_USER_ERROR;
  if (ALLOWED_EXACT.has(msg)) return msg;
  if (ALLOWED_RE.some((re) => re.test(msg)) && msg.length <= 160) return msg;
  if (TECH_RE.some((re) => re.test(msg))) return GENERIC_USER_ERROR;
  // Tout message d'erreur long / technique / API → générique
  if (msg.length > 120) return GENERIC_USER_ERROR;
  if (/erreur|error|fail|échec|impossible/i.test(msg) && !ALLOWED_RE.some((re) => re.test(msg))) {
    return GENERIC_USER_ERROR;
  }
  return msg.length <= 100 ? msg : GENERIC_USER_ERROR;
}
